import { type FC } from 'react';
import { useLazyLoadQuery } from 'react-relay';
import {
    pdpRespMarketplaceSecondaryRootQuery,
    type pdpRespMarketplaceSecondaryRootQueryType,
    type pdpRespMarketplaceSecondaryRootQuery$variables as RelayVariables,
} from '../../../queries/pdpRespMarketplaceSecondaryRoot';

// components
import { PdpRespMarketplaceLayoutSecondaryRefetchContainer } from './PdpRespMarketplaceLayoutSecondaryRefetchContainer';

export const PdpRespMarketplaceLayoutSecondary: FC<{
    relayVariables: RelayVariables;
    afterDisplay: boolean;
}> = ({ relayVariables, afterDisplay }) => {
    const data = useLazyLoadQuery<pdpRespMarketplaceSecondaryRootQueryType>(
        pdpRespMarketplaceSecondaryRootQuery,
        { ...relayVariables, afterDisplay }
    );

    return (
        <PdpRespMarketplaceLayoutSecondaryRefetchContainer
            viewer={data.viewer}
            relayVariables={relayVariables}
        />
    );
};
